// extracted by mini-css-extract-plugin
module.exports = {"rewardsPoints":"jG","tierPointsTitle":"kG","currentTier":"lG","pointsToNextTier":"mG"};